import { useTranslation } from 'react-i18next';

import { DataTable as SharedDataTable } from '../data-display';

const CommentCell = ({ userData = {} }) => {
    const { t } = useTranslation();

    return (
        <SharedDataTable
            columns={[
                {
                    key: 'comment',
                    label: '',
                    width: '100%',
                },
            ]}
            rowKey="comment"
            rows={[
                {
                    comment: userData?.overallImpression ?? t('no_comments_available'),
                },
            ]}
            showHeader={false}
        />
    );
};

export default CommentCell;
